<p class="toast_card alert_msg" *ngIf="show && toast_type==1" id="ptoast_msg">
    <i class="icon-info"></i>
    {{msg}}
</p>
<p class="toast_card warning_msg" *ngIf="show && toast_type==2" id="ptoast_msg">
    <i class="icon-info"></i>
    <a href="javascript:void(0)" (click)="close()" *ngIf="show_close"><i class="icon-close-icon"></i></a>
    {{msg}}
</p>
<p class="toast_card success_msg" *ngIf="show && toast_type==3" id="ptoast_msg">
    <i class="icon-info"></i>
    <a href="javascript:void(0)" (click)="close()" *ngIf="show_close"><i class="icon-close-icon"></i></a>
    {{msg}}
</p>